import React, { useState, useEffect } from "react";
import { MdClose } from "react-icons/md";
import { FaPlus, FaCheck, FaRegCheckSquare, FaRegPlusSquare } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { ScrollableContent } from "../Styles/InputStyles";

const LinkUnlinkProps = ({ linkPropertyMutate, selectedData, setShowLinkUnlinkModel, properties }) => {
    const [linkedProperties, setLinkedProperties] = useState([]);
    const [isApiInProgress, setIsApiInProgress] = useState(false);

    useEffect(() => {
        if (!properties || !selectedData?.propertyList) return;

        const list = Array.isArray(selectedData.propertyList)
            ? selectedData.propertyList.map(p => p.id)
            : [selectedData.propertyList.id];   // ✅ single object → convert to array

        setLinkedProperties(
            properties.filter(prop => prop.name !== "All Properties")
            .map(prop => ({
                ...prop,
                isLinked: list.includes(prop.id),
            }))
        );
    }, [properties, selectedData]);

    const handleToggle = (propId, isLinked) => {
        if (isApiInProgress) return;

        setIsApiInProgress(true);
        setLinkedProperties((prev) =>
            prev.map((prop) =>
                prop.id === propId ? { ...prop, isLoading: true } : prop
            )
        );

        linkPropertyMutate(
            {
                extraChargeId: selectedData?.id,
                toggleValue: isLinked ? 0 : 1,
                propId: propId,
            },
            {
                onSuccess: () => {
                    setLinkedProperties((prev) =>
                        prev.map((prop) =>
                            prop.id === propId
                                ? { ...prop, isLinked: !isLinked, isLoading: false }
                                : prop
                        )
                    );
                    setIsApiInProgress(false);
                },
                onError: () => {
                    setLinkedProperties((prev) =>
                        prev.map((prop) =>
                            prop.id === propId ? { ...prop, isLoading: false } : prop
                        )
                    );
                    setIsApiInProgress(false);
                },
            }
        );
    };

    return (
        <Container>
            <Header>
                <h1 className="text-white text-lg font-medium">Manage Linked Properties</h1>
                <button onClick={() => setShowLinkUnlinkModel(false)}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ScrollableContent className="max-h-screen overflow-y-auto px-6 py-4">
                {linkedProperties.map((prop) => (
                    <PropertyRow key={prop.id}>
                        <Label>{prop.name}</Label>
                        <button
                            onClick={() => handleToggle(prop.id, prop.isLinked)}
                            disabled={prop.isLoading || isApiInProgress}
                        >
                            {prop.isLoading ? (
                                <CircularProgress size={20} />
                            ) : prop.isLinked ? (
                                <FaRegCheckSquare size={20} className="text-green-500 font-normal text-sm" />
                            ) : (
                                <FaRegPlusSquare size={20} className="text-gray-400 font-normal text-sm" />
                            )}
                        </button>
                    </PropertyRow>
                ))}
            </ScrollableContent>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const PropertyRow = tw.div`flex items-center justify-between py-5 border-b`;
const Label = tw.span`text-gray-600`;

export default LinkUnlinkProps;
